import {
  AppstoreOutlined,
  DashboardOutlined,
  EnvironmentOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PercentageOutlined,
  SnippetsOutlined,
  UserOutlined
} from "@ant-design/icons";
import { Badge, Button, Dropdown, Flex, Layout, Space, Tooltip } from "antd";
import CambiarFilial from "components/CambiarFilial";
import { MENU } from "constants/accesos";
import { resetSession } from "hooks/useFilters";
import useStyles from "hooks/useStyles";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { checkAcceso, getAccesosIds } from "utils";
import Notificaciones from "./Notificaciones";
import UserMenu from "./UserMenu";
import AutorizarCae from "components/AutorizarCae";

const BREAKPOINT = 1024;

const Header = ({ collapsed, setCollapsed }) => {
  const usuario = useSelector(state => state.general.usuario);
  const accesosIds = getAccesosIds(usuario?.accesos);
  const accesoVisible = (acceso) => checkAcceso(accesosIds, acceso);

  const {
    colorPrimary,
    colorWhite,
    fontSizeLG,
    headerItemHeight
  } = useStyles();

  const headerStyles = {
    padding: 0,
    display: "flex",
    background: colorPrimary,
    justifyContent: "space-between"
  };

  const buttonStyles = {
    color: colorWhite,
    fontSize: fontSizeLG,
    width: headerItemHeight,
    height: '100%',
  };

  const headerItems = [
    {
      title: "Dashboard",
      href: "/dashboard",
      icon: <DashboardOutlined />,
      hidden: !accesoVisible(MENU.HEADER.DASHBOARD),
    },
    {
      title: "Clientes",
      href: "/clientes",
      icon: <UserOutlined />,
      hidden: !accesoVisible(MENU.HEADER.CLIENTES),
    },
    {
      title: "Seguimiento",
      href: "/seguimiento",
      icon: <EnvironmentOutlined />,
      hidden: !accesoVisible(MENU.HEADER.SEGUIMIENTO),
    },
    {
      title: "Pedidos de retiro",
      href: "/pedidos",
      icon: <SnippetsOutlined />,
      hidden: !accesoVisible(MENU.HEADER.PEDIDOS),
    },
    {
      title: "Indices",
      href: "/indices",
      icon: <PercentageOutlined />,
      hidden: !accesoVisible(MENU.HEADER.INDICES),
    }
  ].filter(i => !i.hidden);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < BREAKPOINT) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Layout.Header style={headerStyles}>
      <div>
        <Button
          type="text"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={() => setCollapsed(!collapsed)}
          style={buttonStyles}
        />
        {!collapsed ? (
          headerItems.map((item, index) => (
            <Link
              key={index}
              to={item.href}
              onClick={() => resetSession("pagination_filters")}
            >
              <Tooltip title={item.title} mouseLeaveDelay={0}>
                <Button
                  type="text"
                  style={buttonStyles}
                  icon={(
                    <Badge count={0} size="small" showZero={false}>
                      <span style={{ color: "#fff" }}>{item.icon}</span>
                    </Badge>
                  )}
                />
              </Tooltip>
            </Link>
          ))
        ) : headerItems?.length > 0 && (
          <Dropdown
            trigger={["hover"]}
            placement="bottomLeft"
            menu={{
              items: headerItems.map((item, index) => ({
                key: index,
                label: (
                  <Link to={item.href}>
                    <Space>
                      {item.icon}
                      {item.title}
                    </Space>
                  </Link>
                ),
              })),
            }}
          >
            <Button
              type="text"
              style={buttonStyles}
              icon={<AppstoreOutlined />}
            />
          </Dropdown>
        )}
      </div>
      <Flex>
        <Notificaciones
          usuario={usuario}
          buttonStyles={buttonStyles}
          accesoVisible={accesoVisible}
        />
        {usuario?.super &&
          <AutorizarCae buttonStyles={buttonStyles} />
        }
        <CambiarFilial
          usuario={usuario}
          buttonStyles={buttonStyles}
        />
        <UserMenu
          usuario={usuario}
          buttonStyles={buttonStyles}
        />
      </Flex>
    </Layout.Header>
  );
};

export default Header;